import { Package, CreditCard } from "lucide-react";

export default function OrderCard({ order }) {
  const {
    id, projectTitle, centre, orderedOn, amount,
    paymentStatus, deliveryStatus, deliveryColor, trackingId, eta,
  } = order;

  return (
    <div className="border border-gray-100 rounded-xl p-5">
      <div className="flex items-start justify-between flex-wrap gap-3 mb-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center shrink-0">
            <Package className="w-4 h-4 text-indigo-600" />
          </div>
          <div>
            <h3 className="font-bold text-gray-900">{projectTitle}</h3>
            <p className="text-xs font-mono text-gray-400">{id}</p>
          </div>
        </div>
        <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${deliveryColor}`}>
          {deliveryStatus}
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mb-4 text-sm">
        <div>
          <p className="text-gray-500 text-xs mb-0.5">Centre</p>
          <p className="font-medium text-gray-900">{centre}</p>
        </div>
        <div>
          <p className="text-gray-500 text-xs mb-0.5">Ordered On</p>
          <p className="font-medium text-gray-900">{orderedOn}</p>
        </div>
        <div>
          <p className="text-gray-500 text-xs mb-0.5">Tracking ID</p>
          <p className="font-medium text-gray-900">{trackingId}</p>
        </div>
        <div>
          <p className="text-gray-500 text-xs mb-0.5">ETA</p>
          <p className="font-medium text-gray-900">{eta}</p>
        </div>
        <div>
          <p className="text-gray-500 text-xs mb-0.5">Amount</p>
          <p className="font-bold text-indigo-600">₹{amount.toLocaleString("en-IN")}</p>
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-gray-100">
        <span className="flex items-center gap-1.5 text-sm font-medium text-gray-600">
          <CreditCard className="w-4 h-4" />
          {paymentStatus}
        </span>

        {paymentStatus === "Payment Pending" ? (
          <button className="bg-gradient-to-r from-indigo-600 to-blue-500 text-white text-sm font-semibold px-5 py-2 rounded-xl hover:opacity-90 transition">
            Pay Now
          </button>
        ) : (
          <button className="border border-gray-200 text-sm font-semibold px-5 py-2 rounded-xl hover:bg-gray-50 transition">
            Track Order
          </button>
        )}
      </div>
    </div>
  );
}